import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  expanded: css``,
};
export const components = {
  title: css``,
  icon: css``,
  content: css``,
  wrapper: css``,
};

export const accordion = css`
  & .${components.title} {
    padding: 16px 12px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    text-align: left;
    &:hover {
      color: ${theme.colors.neutral['50']};
      cursor: pointer;
    }

    &:focus-visible {
      position: relative;
      z-index: 1;
    }

    font-size: 16px;
    line-height: 24px;
    color: ${theme.colors.neutral['95']};
    border-width: 1px 0;
    border-top-color: ${theme.colors.neutral['30']};
  }

  & .${components.icon} {
    color: ${theme.colors.neutral['95']};
    transform: rotate(-90deg);
    transition: all 0.125s ease-in;
    font-size: 14px;

    &.${variants.expanded} {
      transform: rotate(-270deg);
    }
  }

  & .${components.content} {
    padding: 12px;
    color: ${theme.colors.peoople['gris-medio']};
    font-weight: 300;

    &.${variants.expanded} {
    }
  }

  & .${components.wrapper} {
    overflow: hidden;
    transition:
      max-height 0.25s ease-in,
      padding 0.25s ease-in;
    max-height: 0;

    &.${variants.expanded} {
      max-height: var(--accordion-context-height, fit);
    }
  }
`;
